// extracted by mini-css-extract-plugin
export var closeButton = "_g4-2";
export var closeButtonIcon = "_g4-3";
export var lightboxContent = "_g4-1";
export var lightboxOverlay = "_g4-0";